import React from 'react'

class ReadJsonFile   {
    
     static readSetting = (fileName:any) => {
       return fileName;
     }
}

export default ReadJsonFile